import Vue from "vue";
import axios from "axios";
import {
  vuexOidcCreateStoreModule
} from "vuex-oidc";
import {
	oidcSettings
} from '../config/oidc'
import pyChar from 'js-pinyin'
import store from '..'
import qs from 'qs'
//apollo请求
import '@/apolloConfig.js'
import gql from "@/graphql/apollo"
import manageApp from "./manageApp"

const state = {
	loadingDataStart:false,
	targetMessage:'',
	isCanFresh:true,

	//apiMap里的keys需要和路由的名字保持一致
	apiMap:{
		'todo':{
			url:'me/tasks/todo',
			query:''
		},
		'manage':{
			url:'me/processes/guest',
			query:{
				draft:false,
				limit:10,
				start:0,
				keyword:'',
				timestamps:'',
				statuses:'doing',
				locale:'zh',
			}
		},
		'weituo':{
			url:'me/tasks/todo?entrust=true',
			query:'',
		},
		'doing': {
			url: 'me/processes/doing',
			query: {
				limit: 10,
				start: 0,
				keyword: '',
			},
		},
		'done': {
			url: 'me/processes/done',
			query: {
				limit: 10,
				start: 0,
				keyword: '',
			}
		},
		'flow_cc': {
			url: 'me/processes/cc',
			query: {
				limit: 10,
				start: 0,
				unread: true,
				keyword: '',
			},
		},
		'appall': {
			url: 'me/apps',
			query: '',
		}
	},
	dataSource:{
		'todo':[],
		'weituo':[],
		'manage':[],
		'doing':[],
		'done':[],
		'flow_cc':[]
	},
	dataLength:{
		'todo':0,
		'weituo':0,
		'manage':0,
		'done':0,
		'doing':0,
		'flow_cc':0,
		//未读的抄送数量
		'cc': 0,
		//进行中属于自己那方的数量
		'medoing': 0
	},
	appList: [],
	statsRes:{},
	recommends: [],
	tags: [],
	department:[],
	//经过重重筛选之后的apps
	tagApps: [],
	wtThings: {
		'entrustees': [],
		'entrusters': [],
		'total': 0
	},
	process_pass: [],
	favorites: [],
	favoriteApps: [],
	//26个字母
	zm: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
	//由tagApps拿到的字母
	zimu: [],
	highlights: [],
	todoWeiTuo: [],
	appQuery: {
		seq:'',
		tag:'',
		department:''
	},
	userInfos:{}
}


Vue.filter('noNum', function(sortTag) {    // msg 为固定的参数 即是你需要过滤的数据
	let tags = sortTag.split("-");
	if(parseInt(tags[0])>=0){
	  return sortTag.replace(tags[0]+'-','');
	}else{
	  return sortTag;
	}
});

const getters = {

	getAuth: () => store.state.oidcStore,
	getEmail:() => store.state.oidcStore.user.email,
	getUserInfo:()=> store.state.userInfos,
	getId: ()=>store.state.oidcStore.user.account,

	getAppList: state => state.appList,
	getRecommends: state => state.recommends,
	getTags: state => state.tags,
	getDep: state => state.department,
	getTagApps: state => state.tagApps,
	getZimu:state=>state.zimu,

	//拿所有置顶的id
	getHighLights: state => state.highlights,
	//拿所有委托关系
	getWeiTuo:state=>state.wtThings,

	getFavorites: state => state.favorites,
	getFavoriteApps: state => state.favoriteApps,
	getProcess: state => state.process_pass,
	getState: state => state,

	getDataSourceMap: state => state.apiMap,
	getDataSource: state => state.dataSource,
	getDataLength: state => state.dataLength
}

const actions = {

	//拿所有的apps
	async fetchAppList({
		commit,
		state,
		dispatch
	},{filterApps}){
		await axios.get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap['appall'].url}`)
			.then((res) => {
				if (res.data.errno == 0) {
					let appList = res.data.entities.map((item) => {
						let obj = Object.assign({},item);
						obj.shouzimu = pyChar.getFullChars(item.name).toUpperCase().slice(0, 1)
						return obj;
					});

					if(filterApps){
						appList = filterApps(appList);
					}
					state.appList = appList;
					dispatch('getStatus', appList);
					dispatch('metodoLength');
					dispatch('ccsLength');
					dispatch('favoriteGet');
					commit('updateAppList');
					commit('updateAppAll');

				}
			})
			.catch(function (error) {
				console.log(error);
			});
		},	
		
	favoriteGet({commit}){
		axios.get(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps`)
			.then((res) => {
				if (res.data.errno == 0) {
					let id = res.data.entities[0].id
					let favorites = res.data.entities[0].FavoriteApps;
					state.favorites = favorites
					commit('favoriteReset', favorites);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
	metodoLength({dispatch,commit},todoBoolean){
		var sepurl = '';
		var key = 'todo';
		if(todoBoolean===false || todoBoolean === true){
			sepurl = `sep=${todoBoolean}&`;
			key = 'todoNum';
		}
		axios.get(`${window.commonApi.INFOPLUS_URL}/me/tasks/todo?${sepurl}limit=1&start=0`)
			.then((res) => {
				if (res.data.errno == 0) {
					state.dataLength[key] = res.data.total;
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
	AppLength({
		dispatch,
		commit
	  }) {
		axios
		  .get(`${window.commonApi.TASKCENTER_URL}/api/apps/recommended?domain=cloud.ketanyun.cn`)
		  .then((res) => {
		 
			if (res.status == 200) {
			  let appList = res.data.data;
			  commit('updateAppList',appList);
						commit('updateAppAll',appList);
			}
		  })
		  .catch(function (error) {
			console.log(error);
		  });
	  },
	  visitsLength({
		dispatch,
		commit
	  }) {
		axios
		  .get(`${window.commonApi.TASKCENTER_URL}/api/app/views`)
		  .then((res) => {
			if (res.code == 200) {
			  state.dataLength.visitsNum = res.data;
			}
		  })
		  .catch(function (error) {
			console.log(error);
		  });
	  },
	ccsLength({
		dispatch,
		commit
	}) {
		let params = {
			limit: 1,
			start: 0,
			unread: true,
		}
		axios.get(`${window.commonApi.INFOPLUS_URL}/me/processes/cc`, {
				params
			})
			.then((res) => {
				if (res.data.errno == 0) {
					state.dataLength.cc = res.data.total;
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
	medoingsLength({
		dispatch,
		commit
	}) {
		let params = {
			limit: 1,
			start: 0,
			sep: false,
		}
		axios.get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap['doing'].url}`, {
				params
			})
			.then((res) => {
				if (res.data.errno == 0) {
					commit('medoingsNum', {
						'num': res.data.total
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
	async wtTodo({commit},{owner}){
		let wt_owner = owner?'entrustees':'entrusters';
		let id = state.userInfos.id;
		commit('loadingData',true);
		await axios.get(`${window.commonApi.INFOPLUS_URL}/user/${id}/${wt_owner}`)
			.then((res) => {
				if (res.data.errno == 0) {
					let items = res.data.entities
					commit('wtReset',{items,wt_owner});
					commit('loadingData',false);
				}else{
					commit('loadingData',false);
				}
			})
			.catch(function (error) {
				console.log(error);
				commit('loadingData',false);
		});
	},
	//删除委托
	delWt({
		commit
	}, {
		id
	}) {
		let user = state.userId;
		axios.delete(`${window.commonApi.INFOPLUS_URL}/user/${user}/entrustees/${id}`)
			.then((res) => {
				if (res.data.errno == 0) {
					commit('Message','success#删除成功');
				}
			})
			.catch(function (error) {
				console.log(error);
				commit('Message',`error#${error.message}`);
			});
	},
	/*数据操作-------------------------*/
	//获取次数
	getStatus({
		state,commit,dispatch
	}, items) {
		axios.get(`${window.commonApi.INFOPLUS_URL}/stats/apps`)
			.then((res) => {
				if (res.data.errno == 0) {
					let stats = res.data.entities;
					state.statsRes = res.data;
					let appList = items.map(function(item){
					   let id1 = item.id
					   let item2 = stats.filter(function(item){
						   return item.id === id1
					   })
					   let counts = item2[0]?item2[0].processCounters.completed:0
					   item.processCounters = counts
					   return item
				   });

				    commit('updateAppList',appList);
					commit('updateAppAll',appList);
					dispatch('favoriteGet');
			
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
	//首页和全部事项的搜索，tag
	updateQuery({commit,state},{seq,tag,dep}){
		state.appQuery.seq = seq || state.appQuery.seq ;
		state.appQuery.tag = tag || state.appQuery.tag ;
		state.appQuery.department = dep || state.appQuery.department ;
		if(seq === 'all'){
			state.appQuery.seq = '';
		}
		if(tag === 'all'){
			state.appQuery.tag = '';
		}
		if(dep === 'all'){
			state.appQuery.department = '';
		}
		// console.log(state.appQuery);
		commit('updateAppAll');
	},
	//抄送变为已读
	async flow_read({
		dispatch,
		state,
		commit
	},{ids,unread}){
		let ccs =  ids.split(",");
		for(let i in ccs){
			await axios.post(`${window.commonApi.INFOPLUS_URL}/process/${ccs[i]}`,qs.stringify({"action":"read"})).then((res) => {
				if (res.data.errno == 0 ) {
					commit('Message',`success#已标记为已读#${new Date()}`);
					dispatch('resetData',{dataName:'flow_cc'});
				}
			})
			.catch(function (error) {
				commit('Message',`error#${error.message}`);
			})
		}	

	},
	//评分
	Rated({
		state,
		dispatch,
		commit
	}, {
		id,
		rating,
		review
	}) {
		axios.post(`${window.commonApi.INFOPLUS_URL}/process/${id}`, qs.stringify({
				"action": "rate",
				"rating": rating,
				"remark": review
			})).then((res) => {
				if (res.data.errno == 0) {
					commit('Message',`success#评分成功#${new Date()}`);
					dispatch('resetData', {
						dataName: 'done'
					});
				}
			})
			.catch(function (error) {
				console.log(error);
				commit('Message',`error#${error.message}`);

			})
	},
	//需要批量办理时候的多选框
	process_push({
		commit,
		state
	}, {
		id,
		isok,
		clear
	}) {
		if (isok) {
			state.process_pass.push(id)
		} else {
			let arr = state.process_pass.join(',').replace(`${id}`, '').split(',').filter((item) => {
				return item
			})
			state.process_pass = arr
		}

		if (clear) {
			state.process_pass = []
		}
		// console.log(state.process_pass)
		state.process_pass = Array.from(new Set(state.process_pass))
	},
	//批量办理
	process_many({
		dispatch,
		state
	}, actionId) {
		state.process_pass.map((id) => {
			axios.post(`${window.commonApi.INFOPLUS_URL}/task/${id}`, qs.stringify({
					"actionId": actionId
				})).then((res) => {
					if (res.data.errno == 0) {
						dispatch('resetData', {
							dataName: 'todo'
						});
					}
				})
				.catch(function (error) {
					console.log(error);
				})
		})
	},
	//单独一个快捷办理
	process_one({
		dispatch,
		state
	}, {
		actionId,
		id
	}) {
		axios.post(`${window.commonApi.INFOPLUS_URL}/task/${id}`, qs.stringify({
				"actionId": actionId
			})).then((res) => {
				if (res.data.errno == 0) {
					dispatch('resetData', {
						dataName: 'todo'
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},

	//获取流程细节
	processTask({
		commit,
		state
	}, id) {
		axios.get(`${window.commonApi.INFOPLUS_URL}/process/${id}`)
			.then((res) => {
				if (res.data.errno == 0) {
					let items = res.data.entities[0]
					return items
				}
			})
			.catch(function (error) {
				console.log(error);
			})
	},
	//本地存储置顶，逻辑
	highChange({
		commit,
		state
	}) {
		let user = state.oidcStore.user.email;
		let highlights = localStorage.getItem(`${user}_top`).split(',').filter((item) => {
			return item
		})
		commit('HighLightReset', highlights)
	},

	//点击爱心按钮,逻辑,目前放组件里了
	favoriteNow({
		commit
	}, {
		id,
		method
	}) {
		if (method === 'put') {
			axios.put(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`)
				.then((res) => {
					if (res.data.errno == 0) {
						let items = res.data.entities[0].FavoriteApps
						commit('favoriteReset', items)
					} else {
						sessionStorage.setItem('error_res_now', res.data.error);
					}
				})
				.catch(function (error) {
					console.log(error);
					sessionStorage.setItem('error_res_now', error);
				})
		} else {
			axios.delete(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`)
				.then((res) => {
					if (res.data.errno == 0) {
						let items = res.data.entities[0].FavoriteApps
						commit('favoriteReset', items)
					}
				})
				.catch(function (error) {
					console.log(error);
				})
		}
	},
	//将参数原始化
	ClearQ({
		commit,
		state,
		dispatch
	}, {
		dataName
	}) {
		let origin_query = {
			limit: 10,
			start: 0,
			unread: true,
			keyword: '',
		};
		let origin = state.apiMap[dataName];
		if(origin && origin.query){
			for(let key in origin_query){
				if(origin.query.hasOwnProperty(key)){
					origin.query[key] = origin_query[key];
				}
			}
			state.apiMap[dataName].query = origin.query;
		}
		dispatch('resetData',{dataName,'query':origin.query});

	},
	//添加后来的参数，如timestamp
	AddQ({
		state,
		dispatch
	}, {
		dataName,
		property,
		val
	}) {
		if (!state.apiMap[dataName].query.hasOwnProperty(property)) {
			state.apiMap[dataName].query[property] = val;
			dispatch('resetData', {
				dataName,
				query: state.apiMap[dataName].query
			});
		} else {
			dispatch('SearchQ', {
				key: dataName,
				property,
				val
			});
		}
	},
	//调用接口的搜索
	SearchQ({dispatch,commit},{key,property,val,limitRefresh}){
		//limitRefresh阻止刷新
		let str1 = JSON.stringify( state.apiMap[key].query );
			state.apiMap[key].query[property] = val;
		let str2 = JSON.stringify( state.apiMap[key].query );
		if(property != 'start' && property !='limit'){
			state.apiMap[key].query['start'] = 0;
		}
		let query = state.apiMap[key].query;
		let dataName = key;
		//更改参数
		commit('ChangeQ',{dataName,query});

		if(str1 != str2 &&  !limitRefresh){
			dispatch('resetData',{dataName,query});
		}
	},
	async resetData({
		commit,
		state,
		dispatch
	}, {
		dataName,
		query
	}) {
		commit('loadingData', true);
		let url = state.apiMap[dataName].url;
		let params = Object.assign({}, query || state.apiMap[dataName].query);
		if (params.hasOwnProperty('unread') && !params.unread) {
			delete params.unread;
		}
		if(params.hasOwnProperty('keyword')&&!params.keyword){
			delete params.keyword;
		}
		if(params.hasOwnProperty('timestamps')&&!params.timestamps){
			delete params.timestamps;
		}
		dispatch('highChange');
		if(window.commonApi.hasOwnProperty('TASKAPI_URL') && window.commonApi.TASKAPI_URL.length>1 && ['todo','doing','done'].indexOf(dataName)!=-1){
			//参数调整
      		let adjustParams = Object.assign({},params);
			if(adjustParams.hasOwnProperty('start')&&adjustParams.hasOwnProperty('limit')){
				adjustParams.page = (adjustParams.start/adjustParams.limit);
      			adjustParams.size = adjustParams.limit;
      			delete adjustParams.limit;
      			delete adjustParams.start;
			}
			let codeID = getters.getId();
			let nowParams = {
				...adjustParams,
				userId:codeID,
				cate:dataName
			}
			console.log(dataName,'apollo');
			apolloProvider.clients.other.query({
				query: gql[dataName],
				variables: nowParams,
				client:'other',
				fetchPolicy: "network-only",
			  }).then((res) => {
					let items = []
					let total = 0;	
					switch (dataName) {
						case 'todo':
							items = res.data.tasks;
							total = res.data.tasks.length;
							break;
						case 'doing':
							items = res.data.processes.processes;
							total = res.data.processes.total;
							break;
						case 'done':
							items = res.data.processes.processes;
							total = res.data.processes.total;
							break;
					}
						commit('dataGet', {
							items,
							total,
							dataName
						});
					console.log(dataName + '初始化成功！');
					commit('loadingData', false);
			  }).catch(error => {
					console.error(error)
			  });
		}else{
			// if(['todo','doing','done'].indexOf(dataName) === -1){
				await axios.get(`${window.commonApi.INFOPLUS_URL}/${url}`,{params})
				.then((res) => {
					if (res.data.errno == 0) {
						let items = res.data.entities;
						let total = res.data.total;
						commit('dataGet', {
							items,
							total,
							dataName
						});
						console.log(dataName + '初始化成功！');
						commit('loadingData', false);
						switch (dataName) {
							case 'flow_cc':
								dispatch('ccsLength');
								break;
						}
	
					} else {
						commit('loadingData', false);
					}
				})
				.catch(function (error) {
					console.log(error);
					commit('loadingData', false);
				});
			
		}
	},

	/*--------------------------------------*/

}
const mutations = {
	updateAppList(state,apps) {
		if(apps){
			state.appList = apps;
		}
		let appList = state.appList;

		let recommends = [];
		let tags = [];
		let department = [];
		if (appList.length > 0){

			tags = appList.map((item)=>{
				if(item.tags){
					return item.tags.split(",")[0];
				}
			});
			department = appList.map((item)=>{
				if(item.department){
					return item.department.split(",")[0];
				}
			});
			recommends = appList.filter((item)=>{
				return item.recommend && item.recommend > 0;
			});
			tags = tags.filter((item)=>{
				return item;
			});
			department = department.filter((item)=>{
				return item;
			})
			tags = Array.from(new Set(tags));
			department = Array.from(new Set(department));
		}	
		state.recommends = recommends;
		state.tags = tags.sort();
		state.department = department.sort();

	},
	updateAppAll(state,appList){
		if(appList){
			state.appList = appList;
		}
		let all_apps = state.appList;
		if(state.appQuery.seq){
			all_apps = all_apps.filter((item)=>{
				return item.department && item.department.indexOf(state.appQuery.department)>-1;
			});
		}
		if(state.appQuery.tag){
			all_apps = all_apps.filter((item)=>{
				return item.tags && item.tags.indexOf(state.appQuery.tag)>-1;
			});
		}
		if(state.appQuery.department){
			all_apps = all_apps.filter((item)=>{
				return item.department && item.department.indexOf(state.appQuery.department)>-1;
			});
		}

		let zimuS = all_apps.map((item)=>{
			return item.shouzimu;
		})
		state.zimu = Array.from(new Set(zimuS)).sort();
		state.tagApps = all_apps;
	},


	CcthingsReset(state, {
		items,
		total
	}) {
		let sort_ccthings = items.sort((a, b) => {
			if (a.read && b.read) {
				return 0
			} else if (a.read && !b.read) {
				return -1
			} else {
				return 1
			}
		});
		state.ccthings.total = total;
		state.ccthings.val = sort_ccthings;
	},
	favoriteReset(state, favorites) {
		state.favorites = favorites
		state.favoriteApps = state.favorites.map((item1) => {
			let item = state.appList.filter((item2) => {
				return item2.id === item1
			})[0]
			return item
		}).filter((item)=>{return item});
	},
	medoingsNum(state, {
		num
	}) {
		state.dataLength.medoing = num;
	},
	wtReset(state, {
		items,
		wt_owner
	}) {
		state.wtThings[wt_owner] = items;
	},
	HighLightReset(state, highlights) {
		// console.log(highlights);
		state.highlights = highlights.filter((item) => {
			return item
		})
	},
	dataGet(state, {
		items,
		total,
		dataName
	}) {
		state.dataSource[dataName] = items;
		state.dataLength[dataName] = total;
	},
	ChangeQ(state,{dataName,query}){
		state.apiMap[dataName].query = Object.assign({},query);
		// console.log(state.apiMap[dataName].query);
	},
	//骨架屏
	loadingData(state, load_bool) {
		state.loadingDataStart = load_bool;
	},
	//传递消息
	Message(state,word){
		state.targetMessage = word;
	},
	//长链接
	toIsCanFresh(state, bool) {
		state.isCanFresh = bool;
	},
	//profile问题
	setUserInfo(state,obj){
		// console.log(obj);
		state.userInfos = Object.assign({},obj);
	},
	//set appQuery tags
	setChooseTags(state,{tags}){
		state.appQuery.tag=tags;
	},
};

const modules = {
	oidcStore: vuexOidcCreateStoreModule(
		oidcSettings,
		// NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
		// spread your oidcSettings and define a userStore of your choice
		// {
		//     ...oidcSettings,
		//     //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
		// },
		// Optional OIDC store settings
		{
			namespaced: true,
			dispatchEventsOnWindow: true

		},
		// Optional OIDC event listeners
		{
			userLoaded: (user) => console.log('OIDC user is loaded:', user),
			userUnloaded: () => console.log('OIDC user is unloaded'),
			accessTokenExpiring: () => console.log('Access token will expire'),
			accessTokenExpired: () => console.log('Access token did expire'),
			silentRenewError: () => console.log('OIDC user is unloaded'),
			userSignedOut: () => console.log('OIDC user is signed out'),
			oidcError: (payload) => console.log('OIDC error', payload)
		}
	),
	manageApp:manageApp
}

export default {
  modules,
  state,
  getters,
  actions,
  mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/app.js